import { Customer } from 'api/user-domain/user-domain.types';
import { Info } from 'luxon';

export const getCustomerFullName = (customer: Partial<Customer>) => {
  if (customer?.firstName && customer?.lastName)
    return `${customer.firstName} ${customer.lastName}`;
  else if (customer?.firstName) return `${customer.firstName}`;
  else if (customer?.lastName) return `${customer.lastName}`;
  else return '';
};

export const formatMonthDay = (dateStr: string): string | null => {
  if (!dateStr) {
    return null;
  }

  const [month, day] = dateStr.split('-').map(Number);
  const shortMonths = Info.months('short');
  const monthName = shortMonths[month - 1];
  return `${monthName} ${day}`;
};
